export const VISIT_LOCATION_TYPES = {
  AREA: 'area',
  LOCATION: 'location',
};
